import React from "react"

const IconDeaths = () => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="24"
         viewBox="0 0 24 24"
      >
         <path d="M12 0c2.008.002 3.692 1.178 4.766 2.596C17.555 3.638 18.009 4.662 18 6a6.988 6.988 0 01-.092 1c-.241 1.6-1.492 3.898-3.145 6.332A69.604 69.604 0 0020 19l-2 5c-1.506-1.534-3.813-4.122-6-6.909C9.813 19.878 7.506 22.466 6 24l-2-5a69.604 69.604 0 005.237-5.668C7.584 10.898 6.334 8.6 6.092 7A6.988 6.988 0 016 6c-.008-1.338.445-2.362 1.234-3.404C8.308 1.178 9.993.002 12 0zm0 4c-1.838-.009-2.422.469-1.769 2.228.392 1.057 1.014 2.204 1.769 3.37.755-1.166 1.377-2.313 1.769-3.37C14.422 4.469 13.838 3.991 12 4z"></path>
      </svg>
   )
}

export { IconDeaths as default }
